<div id="centerText">{{centerText}}</div>